import { render, staticRenderFns } from "./TransparenciaIndex.vue?vue&type=template&id=9e1ae100&"
import script from "./TransparenciaIndex.vue?vue&type=script&lang=js&"
export * from "./TransparenciaIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports